import http from "../utils/request";
import type { ShopPage, ShopResponse } from "../types/shopMerchant";
import type {
  EntityId,
  GoodsQuery,
  GoodsRow,
  GoodsDetail,
  GoodsWrite,
  GoodsCategoryOption,
  GoodsAudit,
  GoodsShelfChange,
  GoodsRemoteArea,
} from "../types/shopGoods";

export function listGoodsProvinces(signal?: AbortSignal): Promise<ShopResponse<GoodsRemoteArea[]>> {
  return http.get<never, ShopResponse<GoodsRemoteArea[]>>("/biz/area/baseListByType/1", { signal });
}

export function listGoodsCategories(signal?: AbortSignal): Promise<ShopResponse<GoodsCategoryOption[]>> {
  return http.post<never, ShopResponse<GoodsCategoryOption[]>>("/shop/category/list", {}, { signal });
}

export async function listGoods(
  query: GoodsQuery,
  signal?: AbortSignal
): Promise<ShopPage<GoodsRow>> {
  const result = await http.post<never, ShopPage<GoodsRow>>("/shop/goods/list", query, {
    signal,
  });
  return result;
}
export async function exportGoods(query: GoodsQuery): Promise<Blob> {
  const { ypageNum, ypageSize, ...filters } = query;
  const blob = await http.post<never, Blob>("/shop/goods/export", filters, { responseType: "blob" });
  if (!(blob instanceof Blob) || !blob.size || /json|text\//i.test(blob.type))
    throw new Error("导出失败，服务未返回 Excel 文件");
  return blob;
}

export function getGoods(
  id: EntityId,
  signal?: AbortSignal
): Promise<ShopResponse<GoodsDetail>> {
  return http.get<never, ShopResponse<GoodsDetail>>(
    `/shop/goods/detail/${id}`,
    { signal }
  );
}
export function addGoods(data: GoodsWrite): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>("/shop/goods/add", {
    ...data,
    goodsType: 1,
  });
}
export function editGoods(
  data: GoodsWrite & { id: EntityId }
): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>("/shop/goods/edit", data);
}
export function deleteGoods(id: EntityId): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>(`/shop/goods/delete/${id}`, {});
}

export function auditGoods(data: GoodsAudit): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>("/shop/goods/audit", data);
}

export function changeGoodsShelf(data: GoodsShelfChange): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>("/shop/goods/changeShelf", data);
}

export function changeGoodsSort(id: EntityId, sort: number): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>("/shop/goods/changeSort", { id, sort });
}
